import { WORK_ORDER_UI } from '~/app/components/maintenance/work-orders/work-order-ui-colors';
import type { SoftBadgeTone } from '~/app/components/maintenance/work-orders/work-order-ui-colors';

export function statusTone(status: string): SoftBadgeTone {
  switch (status) {
    case 'IN_PROGRESS':
      return WORK_ORDER_UI.status.IN_PROGRESS;
    case 'ON_HOLD':
      return WORK_ORDER_UI.status.ON_HOLD;
    case 'ASSIGNED':
      return WORK_ORDER_UI.status.ASSIGNED;
    case 'PLANNED':
    default:
      return WORK_ORDER_UI.status.PLANNED;
  }
}

export function clusterKey(cluster: {
  siteId: string;
  isoWeekKey: string;
  workOrderIds: string[];
}): string {
  return `${cluster.siteId}:${cluster.isoWeekKey}:${cluster.workOrderIds.join(',')}`;
}
